// Function loadChatbotBlock loads the ChatbotBlock class by dynamically importing the js on demand if needed

export function loadChatbotBlock($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-chatbot-block-chunk" */ '../widgets/chatbotBlock').then(wg => {

		const { ChatbotBlock } = wg;

		let $wg = $parentEl.querySelector('[data-wg="ChatbotBlock"]');

		if(!$wg) {
			// console.info('ChatbotBlock: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="ChatbotBlock"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new ChatbotBlock($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new ChatbotBlock($wg);
		}


	}).catch(error => error+'An error occurred while loading the ChatbotBlock widget');

}
